import axios from 'axios';

import { BrowserActivityTracker } from '@inspiren-monorepo/activity-tracker-browser';

import unauthorizedInterceptor from './interceptors/unauthorized.interceptor';

import { getApiBaseUrl } from '../config/apiUrlConfig';

import type { Auth0ContextInterface } from '@auth0/auth0-react';

const Api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
});

Api.interceptors.request.use((config) => {
  const newConfig = config;
  newConfig.headers['X-Application-Name'] = 'virtual-care';
  newConfig.headers['X-Session-Id'] = BrowserActivityTracker.getSessionId();
  return newConfig;
});

unauthorizedInterceptor(Api);

export const addAuthHeader = (
  getToken: Auth0ContextInterface['getAccessTokenSilently'],
) => {
  Api.interceptors.request.use(async (config) => {
    const token = await getToken();
    const newConfig = config;
    newConfig.headers.Authorization = `Bearer ${token}`;
    return newConfig;
  });
};

export { Api };
